"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function enj(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M16.7347 6.74994C17.1052 6.79269 17.4802 6.81594 17.8462 6.88194C18.5714 7.01919 18.8084 7.36419 18.6854 8.06394C18.6359 8.34744 18.4529 8.52219 18.1619 8.56944C17.9885 8.59386 17.8136 8.60639 17.6384 8.60694C15.2587 8.61219 12.8737 8.61669 10.4939 8.62644C10.1339 8.62644 9.77766 8.65944 9.42741 8.71644C8.24691 8.90094 7.80291 9.36894 7.70391 10.5074C7.65891 11.0422 7.65891 11.0422 8.21766 11.0422H17.9887C18.1424 11.0467 18.2902 11.0752 18.4184 11.1547C18.8534 11.4202 18.7447 11.8357 18.7199 12.2189C18.7004 12.5264 18.5077 12.6959 18.1769 12.7574C18.038 12.7787 17.8975 12.7882 17.7569 12.7859H8.01441C7.65441 12.7859 7.65966 12.7859 7.68891 13.1264C7.71366 13.4384 7.73391 13.7459 7.81266 14.0482C7.96041 14.6107 8.32116 14.9602 8.90391 15.1162C9.55041 15.2909 10.2172 15.3292 10.8839 15.3337C13.2089 15.3479 15.5302 15.3434 17.8559 15.3434C18.1522 15.3434 18.4282 15.3809 18.6014 15.6412C18.9374 16.1422 18.6757 16.8412 18.0877 17.0212C17.5844 17.1772 17.0557 17.2147 16.5322 17.2199C14.3497 17.2574 12.1672 17.2627 9.98466 17.2199C9.31159 17.2026 8.6412 17.1283 7.98066 16.9979C6.42516 16.6904 5.64966 15.9344 5.38791 14.4404C5.32866 14.0954 5.29416 13.7459 5.24991 13.4002V10.6732C5.27991 10.4032 5.30391 10.1347 5.33916 9.86994C5.54616 8.17719 6.33666 7.34544 8.07441 6.97719C8.69166 6.84444 9.32316 6.81594 9.94566 6.75444C12.2024 6.74994 14.4674 6.74994 16.7347 6.74994Z", fill: color }));
}
exports["default"] = enj;
//# sourceMappingURL=enj.js.map